import React from 'react';

export default function WizardHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      {/* Brim */}
      <ellipse cx="20" cy="36" rx="18" ry="4" fill="#4527A0" />
      {/* Cone */}
      <path d="M6 36L20 4L34 36Z" fill="#5E35B1" />
      {/* Tip curl */}
      <path d="M20 4C20 4 24 2 26 6" stroke="#5E35B1" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      {/* Stars */}
      <circle cx="14" cy="24" r="1.5" fill="#FFD54F" />
      <circle cx="24" cy="18" r="1" fill="#FFD54F" />
      <circle cx="18" cy="14" r="1.2" fill="#FFD54F" />
      {/* Band */}
      <path d="M8 32L32 32" stroke="#FFD54F" strokeWidth="2" />
    </svg>
  );
}
